import React, { useState, useEffect } from 'react'
import './newMatches.css'
import FiltersSideBar from './FiltersSideBar';
import MatchCardListContainer from './MatchCardListContainer';
import axios from 'axios';
import key from '../../key';
import { useCookies } from 'react-cookie';

function FilterMatchesScreen({ user, matches, title }) {
    // eslint-disable-next-line
    const [cookies, setCookie, removeCookie] = useCookies(['x-auth-token'])
    const [filteredMatches, setFilteredMatches] = useState([])
    //eslint-disable-next-line
    const [filters, setFilters] = useState(
        {
            photoSettings: [],
            maritalStatus: [],
            educationLevel: [],
            diet: []
        }
    )
    useEffect(() => {
        const filteredContacts = async () => {
            try {
                const res = await axios.post(`${key}/api/user/filter-matches`, filters, {
                    headers: {
                        'x-auth-token': cookies['x-auth-token']
                    }
                }
                )
                setFilteredMatches(res.data.matches)
            } catch (error) {
                console.log(error)
            }
        }
        filteredContacts();
        // eslint-disable-next-line
    }, [filters])
    return (
        <div className="container new-matches-container">
            <div className="row">
                <div className="col col-sm-12 col-md-3 col-lg-2">
                    <FiltersSideBar filters={filters} setFilters={setFilters} />
                </div>
                <div className="col col-sm-12 col-md-6 col-lg-8">
                    <MatchCardListContainer user={user} matches={filteredMatches} title={title} />
                </div>
                {/* <div className="col col-sm-12 col-md-3 col-lg-2">
                    <ChatWidget />
                </div> */}
            </div>
        </div>
    )
}

export default FilterMatchesScreen